var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"ci-youtube",attrs:{"src":("https://www.youtube.com/embed/" + _vm.videoId),"frameborder":"0","allow":"accelerometer;autoplay;encrypted-media;gyroscope;picture-in-picture","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }